<script setup lang="ts">
const article = inject(keys.currentArticle);
</script>

<template>
  <h1 class="hyphens-auto font-headline md:hyphens-manual" v-html="article?.title" />
</template>
